<!-- 衣鞋洗护 -->
<template>
    <!-- 说明 -->
    <div class="booknowbox">
        <div class="booknow">
            <div class="imagestitle">
                <van-image style="background-color: #f7f7f7;" fit="contain" height="70" :src="squareUrl" />
            </div>

            <!-- 信息告知 -->
            <div class="inform">
                <van-image :src="item" v-for="(item, index) in introduces" :key="index" />
            </div>

            <van-cell-group title="服务信息">
                <van-cell title="服务内容" :value="serverName" />
                <van-field v-model="policyNo" label="兑奖码" placeholder="请输入兑奖码号码" :maxlength="11" clearable/>
            </van-cell-group>

            <van-cell-group title="联系人信息">
                <van-field v-model="userName" label="联系人" placeholder="请输入联系人姓名" :maxlength="8" clearable/>
                <van-field v-model="userTel" label="电话" placeholder="请输入联系人电话" type="tel" :maxlength="11" clearable/>
            </van-cell-group>

            <van-cell-group title="地址信息">
                <van-field v-model="userRegion" is-link readonly label="服务区域" placeholder="请选择服务区域"
                    @click="isCityState = true" />
                <van-field v-model="userAddress" rows="3" autosize label="详细地址" type="textarea" maxlength="50"
                    placeholder="请输入取件上门详细地址（取件/收件地址）" show-word-limit clearable/>
            </van-cell-group>

            <!-- 预约时间 -->
            <van-field v-model="selectedTime" is-link readonly label="取件时间" placeholder="请选择取件上门时间"
                @click="openDateTimePopup" />

            <!-- 选择预约时间弹窗 -->
            <van-popup v-model="showPicker" position="bottom">
                <div class="databox">
                    <span>请选择取件时间：</span>
                    <van-tree-select height="80vw" :items="items" :active-id.sync="activeLeft"
                        :main-active-index.sync="activeRight" @click-nav="clickLeft" @click-item="clickRight" />
                </div>
            </van-popup>

            <div class="buttons">
                <van-button style="width: 95%;" type="primary" color="#dd5307" block @click="BookNow()"
                    :disabled="isButton()" loading-text="提交预约中..." :loading="isBtnLoad">立即预约</van-button>
            </div>

            <!-- <van-divider>最终解释权归楚天惠家保所有</van-divider> -->

            <!-- 地址选择弹窗 -->
            <van-popup v-model="isCityState" round position="bottom">
                <van-cascader v-model="cascaderValue" title="请选择所在地区" :options="options" @close="isCityState = false"
                    @finish="onFinish" />
            </van-popup>

            <!-- 加载窗口 -->
            <!-- 全屏加载遮罩 -->
            <van-overlay :show="isLoading" z-index="2000">
                <div class="full-loading">
                    <van-loading type="spinner" size="40px" color="#1989fa" />
                    <p class="loading-text">加载中...</p>
                </div>
            </van-overlay>
        </div>
    </div>

</template>

<script>
import { Dialog } from 'vant';
import { PostMsg } from '../constant.js'
import { CITY_LIST } from '../city.js'

export default {
    components: {},
    data() {
        return {
            introduces: [
                require('@/assets/衣鞋洗护/1.png'),
                require('@/assets/衣鞋洗护/2.png'),
                require('@/assets/衣鞋洗护/3.png')
            ],
            squareUrl: require('@/assets/logorow.png'),
            // radio: '',
            cascaderValue: '', // 地址弹窗值
            options: CITY_LIST, // 地址选择
            isBtnLoad:false, // 按钮状态

            userName: '',// 联系人
            userTel: '', // 联系电话
            userRegion: '', // 服务区域
            userAddress: '', // 服务地址
            isCityState: false, // 地址弹窗
            policyNo: '', // 兑奖码

            // serverTypeList: [],// 服务类型
            serverType: '',// 服务类型
            serverName: '京东衣鞋任意 2 件洗护',// 服务名称
            isLoading: false,// 全屏加载

            // 预约时间
            showPicker: false, // 时间预约弹窗
            selectedTime: '',// 预约时间值
            items: [], // 时间数据
            activeLeft: 0,
            activeRight: 0,
        };
    },
    watch: {

    },
    mounted() {
    },
    methods: {
        // 点击左侧的按钮
        clickLeft(index) {
            // this.activeLeft = index
        },
        // 点击右侧的按钮
        clickRight(date) {
            console.log(date);
            this.selectedTime = `${date.day} / ${date.text}`
            // 增加逻辑关闭弹窗
            this.showPicker = false
        },
        // 根据现在的时间调整数据
        generateSevenDayTimeItems() {
            // 设置 now 为“后天的 00:00:00”
            const today = new Date();
            const now = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3); // 后天 00:00

            const result = [];

            const timePeriods = [
                { id: 1, text: '上午（09:00-12:00）', startHour: 9, endHour: 12 },
                { id: 2, text: '中午（12:00-14:00）', startHour: 12, endHour: 14 },
                { id: 3, text: '下午（14:00-18:00）', startHour: 14, endHour: 18 },
                { id: 4, text: '晚上（18:00-20:00）', startHour: 18, endHour: 20 },
            ];

            for (let i = 0; i < 7; i++) {
                const date = new Date(now.getTime() + i * 86400000);
                const y = date.getFullYear();
                const m = ('0' + (date.getMonth() + 1)).slice(-2);
                const d = ('0' + date.getDate()).slice(-2);
                const mmdd = `${m}-${d}`;
                const ymd = `${y}-${m}-${d}`;
                const labelPrefix = this.getWeekDayLabel(date);

                const children = timePeriods.map(period => ({
                    id: `${ymd}-${period.id}`,
                    text: period.text,
                    day: ymd
                }));

                result.push({
                    text: `${labelPrefix}(${mmdd})`,
                    children
                });
            }

            return result;
        },
        getWeekDayLabel(date) {
            const weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
            return weekList[date.getDay()];
        },
        // 打开时间选择弹窗
        openDateTimePopup() {
            // 根据现在的时间调整数据
            this.items = this.generateSevenDayTimeItems();
            this.showPicker = true
        },
        // 监听按钮
        isButton() {
            const {
                userName,
                userTel,
                userRegion,
                userAddress,
                policyNo,
                selectedTime
            } = this;

            // 基础必填字段
            const baseFields = [userName, userTel, userRegion, userAddress, policyNo];
            return baseFields.concat([selectedTime]).some(field => field === '');
        },
        // 地址解析
        onFinish({ selectedOptions }) {
            this.isCityState = false;
            this.userRegion = selectedOptions.map((option) => option.text).join('-');
        },
        // 获取服务类型的集合
        // getFindSampleDate(sampleId) {
        //     this.isLoading = true // 关闭加载
        //     PostMsg('/temporaryMsg/findSample', {
        //         sampleId: sampleId
        //     }).then(res => {
        //         console.log('获取活动配置：', res);
        //         if (res.data.state == 200) {
        //             // this.serverTypeList = res.data.data
        //             this.isLoading = false // 关闭加载

        //             if (res.data.data.returnType == '0') {// 未服务状态
        //                 const { service_type_id, service_type_name, activity_code } = res.data.data

        //                 // this.policyNo = activity_code
        //                 this.serverType = service_type_id
        //                 this.serverName = service_type_name

        //             } else if (res.data.data.returnType == '1') { // 已服务状态

        //                 const { policy_no } = res.data.data
        //                 this.$router.push({
        //                     path: '/app/successnow',
        //                     query: {
        //                         policyNo: policy_no,
        //                     }
        //                 });

        //             } else if (res.data.data.returnType == '-1') {
        //                 Dialog.alert({
        //                     title: '警告',
        //                     message: '链接有误，无法使用服务',
        //                     showConfirmButton: false
        //                 })
        //             }
        //         } else {
        //             console.log('异常');
        //             this.$message.error('加载错误');
        //         }

        //     })
        // },
        // 立即预约
        BookNow() {

            this.isBtnLoad=true

            // 校验数据
            const {
                userName,
                userTel,
                userRegion,
                userAddress,
                policyNo,
                selectedTime
            } = this


            const parent = new FormData()
            parent.append('channel', '1') // 渠道
            parent.append('couponCode', policyNo)
            parent.append('contacts', userName)
            parent.append('contactsTel', userTel)
            parent.append('region', userRegion)
            parent.append('address', userAddress)
            parent.append('mailTime', selectedTime)
            parent.append('typeServiceId', "GS0010")

            // 提交到服务器
            PostMsg('/temporaryMsg/orderBookNowCoupon', parent).then(res => {
                console.log('立即预约：', res);
                this.isBtnLoad=false
                if (res.data.state == 200) {
                    const { data } = res.data

                    if (data.state == '-1') { // 无效或失效
                        Dialog.alert({
                            title: '警告',
                            message: '兑换码有误请重新输入'
                        })
                    } else if (data.state == '1') { // 已经使用
                        Dialog.alert({
                            title: '警告',
                            message: '兑换码已使用请重新输入'
                        })
                    } else if (data.state == '0') { // 提交成功
                        this.$router.push({
                            path: '/app/successnow',
                            query: {
                                policyNo: data.date.policy_no,
                            }
                        });
                    }
                } else {
                    this.$message.error('预约错误');
                }
            })
        }
    }
}


</script>

<style lang="less" scoped>
.booknowbox {
    position: absolute;
    width: 100%;
    // height: 100%;
    background-color: #f7f7f7;
    display: flex;
    justify-content: center;
    font-size: 16px !important;

    .booknow {
        position: relative;
        width: 100%;
        background-color: #f7f7f7;
        display: flex;
        flex-direction: column;
        max-width: 650px;

        .inform {
            // margin: 10px;
            // border: 1px solid red;
            display: flex;
            flex-direction: column;
            margin-top: 20px;
            margin-bottom: 20px;
        }


        .imagestitle {
            margin-top: 20px;
            margin-left: 20px;
            // width: 100%;
            // border: 1px solid red;

            // display: flex;
            // align-items: center;
            // justify-content: center;
        }

        .van-cell-group__title::before {
            content: '';
            // width:10px;
            // height: 10px;
            // background-color: #dd5307;
            border: 2px solid #dd5307;
            margin-right: 5px;
        }

        .buttons {
            margin-top: 20px;
            margin-bottom: 50px;
            width: 100%;
            // border: 1px solid red;
            display: flex;
            align-items: center;
            justify-content: center;
        }


        .full-loading {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
        }

        .loading-text {
            margin-top: 10px;
            color: #fff;
            font-size: 14px;
        }

        .databox {
            margin: 10px;
        }
    }
}
</style>